<template>
  <div class="main">
    <FormWrapper
      :action="route('enroll.online.confirm')"
      method="POST"
      @submit="formSubmitted"
    >
      <div class="title-bar">
        <div class="row">
          <div class="col-12 col-md-6 mb-4 text-center text-md-left">
            <h1 class="mb-0">Online Enrollment Confirmation</h1>
          </div>
          <div class="col-12 col-md-6 mb-3 text-center text-md-right">
            <button
              type="submit"
              class="d-none d-lg-inline-block btn btn-success mr-2"
              :class="{ disabled: submitted === true }"
            >
              Confirm Purchase
            </button>
            <a class="btn btn-info mr-2" :href="route('enroll.online.cart')"
              >Edit Cart</a
            >
            <a class="btn btn-danger" :href="route('catalog.online')"
              >Back to Catalog</a
            >
          </div>
        </div>
      </div>

      <div class="enrollment-confirmation content py-4 px-xl-2">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>

            <div class="col-12 col-lg-8">
              <div class="checkout-items panel p-4 mb-4">
                <h3 class="text-center text-primary font-weight-bold mb-4">
                  Enrollments included in this purchase
                </h3>
                <CheckoutItem
                  v-for="(item, i) in queue.items"
                  :key="i"
                  :item="item"
                  :index="i"
                />
              </div>

              <PaymentForm
                v-if="total > 0 && $root.windowWidth >= 992"
                :order="order"
              />
            </div>

            <div class="col-12 col-lg-4">
              <div class="sticky-top">
                <div class="checkout-summary panel p-4 mb-4">
                  <h3 class="text-center text-primary font-weight-bold">
                    Purchase Summary
                  </h3>
                  <div class="row" style="font-size: 14px">
                    <div class="col-8">
                      Subtotal ({{ queue.items.length }} items)
                    </div>
                    <div class="col-4 text-right">{{ subtotal | cost }}</div>
                  </div>
                  <div
                    v-if="!!coupon"
                    class="row text-primary"
                    style="font-size: 14px"
                  >
                    <div class="col-8">Coupon: {{ coupon.code }}</div>
                    <div class="col-4 text-right">- {{ discount | cost }}</div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col font-weight-bold">
                      <h3>Total</h3>
                    </div>
                    <div class="col font-weight-bold text-right">
                      <h3>* {{ total | cost }}</h3>
                    </div>
                  </div>
                  <p class="font-size-sm">
                    * The total amount that will be charged to your credit card
                  </p>
                </div>

                <CouponForm
                  v-if="subtotal > 0"
                  :coupon="coupon"
                  @apply="applyCoupon"
                  @remove="removeCoupon"
                />

                <div class="checkout-referral panel p-4 mb-4">
                  <h3 class="text-center text-primary font-weight-bold">
                    Have a referral code?
                  </h3>
                  <p>
                    Enter it in the field below and it will be applied once you
                    confirm your purchase.
                  </p>
                  <Field
                    type="text"
                    name="referral_code"
                    v-model="referralCode"
                  />
                </div>

                <PaymentForm
                  v-if="total > 0 && $root.windowWidth < 992"
                  :order="order"
                />

                <div class="text-center">
                  <button
                    type="submit"
                    class="btn btn-success w-75 w-sm-auto w-lg-75 w-xl-auto mb-3 mb-sm-0 mb-lg-3 mb-xl-0 mr-sm-2 mr-lg-0 mr-xl-2"
                    :class="{ disabled: submitted === true }"
                  >
                    Confirm Purchase
                  </button>
                  <a
                    class="btn btn-danger w-75 w-sm-auto w-lg-75 w-xl-auto"
                    :href="route('catalog.online')"
                    >Back to Catalog</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import CheckoutItem from "./partials/CheckoutItem";
import PaymentForm from "./partials/PaymentForm";
import CouponForm from "./partials/CouponForm";

export default {
  mixins: [DisplaysAlerts],
  components: { CheckoutItem, PaymentForm, CouponForm },
  props: {
    queue: { type: Object, required: true },
    order: { type: Object, required: true },
  },
  data() {
    return {
      subtotal: null,
      discount: null,
      total: null,
      coupon: null,
      referralCode: null,
      submitted: false,
    };
  },
  methods: {
    applyCoupon(coupon, subtotal, discount, total) {
      this.coupon = coupon;
      this.subtotal = subtotal;
      this.discount = discount;
      this.total = total;
    },
    removeCoupon() {
      this.coupon = null;
      this.discount = null;
    },
    formSubmitted() {
      this.submitted = true;
      this.$root.showLoading(
        "Finalizing your enrollment request. Please wait..."
      );
    },
  },
  created() {
    this.subtotal = this.order.subtotal;
    this.discount = this.order.discount;
    this.total = this.order.total;
    this.coupon = !!this.order.coupon ? this.order.coupon : null;
    this.referralCode = !!this.order.referral ? this.order.referral : null;
  },
};
</script>